var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleOrthopaedicSurgery from '../../schemas/module-orthopaedic-surgery.json';
var SchemaModuleOrthopaedicSurgery = (function (_super) {
    __extends(SchemaModuleOrthopaedicSurgery, _super);
    function SchemaModuleOrthopaedicSurgery() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleOrthopaedicSurgery);
        return _this;
    }
    return SchemaModuleOrthopaedicSurgery;
}(SchemaModuleUniversal));
export { SchemaModuleOrthopaedicSurgery };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-orthopaedic-surgery.ts.pre-build-optimizer.js